import { formatWeekLabel } from '../../utils/metricsFormat';

/** Barras verticais — throughput por semana (CONCLUSÕES, não cartões: ver comentário em BOARD_METRICS_SQL). */
export default function WeeklyBarChart({ points }) {
  if (!points.length) {
    return <div className="text-xs text-text-secondary py-8 text-center">Sem conclusões no período.</div>;
  }
  const max = Math.max(1, ...points.map((p) => p.completed));
  return (
    <div className="flex items-end gap-2 overflow-x-auto pb-1">
      {points.map((p) => {
        const h = p.completed > 0 ? Math.max(4, (p.completed / max) * 100) : 0;
        return (
          <div key={p.week_start} className="flex flex-col items-center gap-1 shrink-0 w-10">
            <div className="text-[11px] text-text-primary font-medium tabular-nums">{p.completed}</div>
            <div className="w-full h-24 flex items-end bg-white/5 rounded overflow-hidden">
              <div className="w-full bg-accent rounded-t" style={{ height: `${h}%` }} />
            </div>
            <div className="text-[10px] text-text-secondary" title={p.week_start}>{formatWeekLabel(p.week_start)}</div>
          </div>
        );
      })}
    </div>
  );
}
